// This modules is ment to be used only by vuetifyWithTranslationIntegration.ts because we need to integrate
// current crowdworx translations solution with "vue-i18" library and Vuetify internatiolization support.
// DO NOT import it anywhere else!

import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

// This a an integration code so we can use "vue-i18n" library with translations that are currently used on Crowdworx website.
// Because this "frontend" project is included into current Analyx.CWX.Website project that means that all JS global variables
// that are defined there are also available in this project. We can use that fact and use app.utils.translations "module"
// (it's not real ES module, it's just a global object with some functions) to get object with all translation messages.
// We can also use global variable "MasterConfigInstance" that contains information about current language. We use this
// two datas to configure "vue-i18n" library.
//
// If we are using development server (by "yarn run serve") then we have some workaround code to actually call JS file generated
// by Website projects that sets translations messages object to app.utils.translations "module". Before doing that (by use of
// "require" function) we "mock" global app.utils.translations variable to intercept this messages object and also define global
// MasterConfigInstance variable to set current language for development purpose.
// Because required translations file (app.utils.translationsJson.js) is generated on startup of Website project you need to run
// crowdworx website at least once before using "yarn run serve" for development

type CrowdworxWebsiteTranslations = {
  [languageKey: string]: { [key: string]: any };
};
declare var app: {
  utils: {
    translations: {
      getAllTranslationsObject: () => CrowdworxWebsiteTranslations;
    };
  };
};
declare var MasterConfigInstance: {
  currentLang: "de-DE" | "en-GB" | "es-ES" | "ja-JP" | "zh-CN";
};

if (process.env.VUE_APP_CWX_DEV_SERVER) {
  (window as any).MasterConfigInstance = {
    currentLang: process.env.VUE_APP_CWX_CURRENT_LANG
  };

  let TRANSLATIONS: CrowdworxWebsiteTranslations;
  (window as any).app = {
    utils: {
      translations: {
        setTranslations(translations: CrowdworxWebsiteTranslations) {
          // console.log("calling fake setTranslations with args:", translations);
          TRANSLATIONS = translations;
        },
        getAllTranslationsObject() {
          return TRANSLATIONS;
        }
      }
    }
  };

  require("../../../../Analyx.CWX.Website/Scripts/generated/app.utils.translationsJson.js");
}

const locale = MasterConfigInstance.currentLang;
let messages = app.utils.translations.getAllTranslationsObject();

const i18n = new VueI18n({
  locale: locale,
  messages: messages
});

export { i18n };
